module.exports = __webpack_public_path__ + "img/20210906-1630898400625526.2a30ba12.jpg";